module.exports = __webpack_public_path__ + "static/media/arrow-collapse-blue.c0c9fa8d.svg";